export const EXPORT_ROUTE = 'app.export';
export const EXPORT_MODAL = {
    url: '/exportOptions',
    templateUrl: 'app/components/export/export-modal.html',
    controller: 'ExportModalController',
    controllerAs: 'vm',
    size: 'md',
    backdrop: 'static',
    keyboard: false,
    multiple: true
};

export class ExportRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider
          .state(EXPORT_ROUTE, EXPORT_MODAL);
    }
}
